/* No Nuts 2026 homepage enhancements. Optional polish only: the page works without this file. */
(() => {
  // Judge.me prints the rating line as "4.84 ★ (1,129)". Reword it to the designer's
  // "4.84 / 5 from 1,129 reviews". If Judge.me changes its markup this quietly does nothing.
  const formatRating = () => {
    document.querySelectorAll('.main .jdgm-cards-carousel .jdgm-rating-text:not([data-nn])').forEach((el) => {
      const count = el.querySelector('.jdgm-reviews-count');
      const rating = el.textContent.match(/^\s*(\d+(?:\.\d+)?)/);
      if (!count || !rating) return;
      // Judge.me adds the thousands separator later with its own script, so format it here.
      const total = Number(count.textContent.replace(/[^\d]/g, ''));
      if (!total) return;
      el.dataset.nn = '1';
      el.textContent = `${rating[1]} / 5 from ${total.toLocaleString('en-US')} reviews`;
    });
  };

  formatRating();

  // Judge.me can render or re-render its widget after the page loads.
  const main = document.querySelector('.main');
  if (main && 'MutationObserver' in window) {
    const observer = new MutationObserver(formatRating);
    observer.observe(main, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  }
})();
